import DistributionLossData from './distribution_loss_data'

export default {
  modules: {
    DistributionLossData
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/loss_system/distribution_loss/index.js